<template>
  <div class="dian">
   <div class="sks"><span @click=" onClickLeft">
        ＜ </span>
    </div>
    <img src="../../assets/yy/l1.jpg" alt="">
    <div v-show="$store.state.shopid==1" class="cs">
      <div class="cs1">
        <div @click="ga(1)" class="xi">
          <img v-show="xid!=1" src="../../assets/yy/1.png" alt="">
          <img v-show="x1id==1" src="../../assets/yy/001.png" alt="">
        </div>
        <div @click="ga(2)" class="xi">
          <img v-show="xid!=2" src="../../assets/yy/12.png" alt="">
          <img v-show="x1id==2" src="../../assets/yy/0012.png" alt="">
        </div>
        <div @click="ga(3)" class="xi">
          <img v-show="xid!=3" src="../../assets/yy/6.png" alt="">
          <img v-show="x1id==3" src="../../assets/yy/007.png" alt="">
        </div>
        <div @click="ga(4)" class="xi">
          <img v-show="xid!=4" src="../../assets/yy/032.png" alt="">
          <img v-show="x1id==4" src="../../assets/yy/02.png" alt="">
        </div>
        <div @click="ga(5)" class="xi">
          <img v-show="xid!=5" src="../../assets/yy/0.png" alt="">
          <img v-show="x1id==5" src="../../assets/yy/008.png" alt="">
        </div>
         <div @click="ga(6)" class="xi">
          <img v-show="xid!=6" src="../../assets/yy/4.png" alt="">
          <img v-show="x1id==6" src="../../assets/yy/005.png" alt="">
        </div>
         <div @click="ga(7)" class="xi">
          <img v-show="xid!=7" src="../../assets/yy/5.png" alt="">
          <img v-show="x1id==7" src="../../assets/yy/006.png" alt="">
        </div>
         <div @click="ga(8)" class="xi">
          <img v-show="xid!=8" src="../../assets/yy/11.png" alt="">
          <img v-show="x1id==8" src="../../assets/yy/0011.png" alt="">
        </div>
          <div @click="ga(9)" class="xi">
          <img v-show="xid!=9" src="../../assets/yy/10.png" alt="">
          <img v-show="x1id==9" src="../../assets/yy/010.png" alt="">
        </div>
       
        <div @click="ga(10)" class="xi">
          <img v-show="xid!=10" src="../../assets/yy/156.png" alt="">
          <img v-show="x1id==10" src="../../assets/yy/03.png" alt="">
        </div>
                      
        <div @click="ga(11)" class="xi">
          <img v-show="xid!=11" src="../../assets/yy/2.png" alt="">
          <img v-show="x1id==11" src="../../assets/yy/003.png" alt="">
        </div>
      </div>
    </div>

    <div v-for="v in s_list" @click="gos(v.store_son_id)" :key="v.store_son_id" class="xq">
               <img  :src="v.store_logo_two" alt="">

    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Specs from './specs1.vue'
import { NavBar, AddressList, Toast,Swipe, SwipeItem, Lazyload,CountDown,Progress } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true }).use(CountDown).use(Progress);
export default {
  created () {
     this.axios.get('getAllThreeClass',{params:{ store_id: this.$store.state.shopid}}).then(res=>{
            // console.log(res)
            // this.s_list=res.data.data

            res.data.info.forEach(v => {
              // console.log(v.name)

              if(['生态板','石膏板','轻钢龙骨','密度板','阻燃板','欧松板','木方','五金辅材','隔音棉','油漆*涂料','劳保用品'].indexOf(v.name)!=-1){

                this.list.push(v)
              }
            })
          // console.log(this.list)
          this.list.sort(function(a,b){
              return a.sort-b.sort
            })
          }).catch(ref=>{})
            this.axios.get('getSonShop',{params:{ store_id: this.$store.state.shopid}}).then(res=>{
            this.s_list=res.data.data
          }).catch(ref=>{})
  },
  data () {
    return {
     xid:1,
     x1id:1,
     list:[],
     slist:[1,2,3],
     s_list:[]
    };
  },
  methods: {
 
    onClickLeft () {
      this.$router.go(-1)
    },
    ga(v){
      this.xid=v
      this.x1id=v
      this.gon(v)
    },
    gos(i){
       this.$store.state.sonid=i
      this.$router.push('shop')
    },
    gon(i){
        this.axios.get('getSonShop',{params:{ store_id: this.$store.state.shopid,class_id:this.list[i-1].id}}).then(res=>{
            this.s_list=res.data.data
          }).catch(ref=>{})
    }
   
    
    
  },
  components: {
    Specs,
    // One
  },
}
</script>
<style lang="less" scoped>
.dian{
  overflow: hidden;
  padding-top: 1rem;
  background-color: #080e1e;

}
.xq{
  padding: 0.2rem;
}
.sks {
  width: 100%;
  z-index: 99;
  height: 1rem;
  background-color: #080e1e;
  color: #feffff;
  text-align: center;
  font-size: 0.4rem;
  line-height: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  //   margin-top: 0.5rem;
  // position: fixed;
  // top: 0;
  // z-index: 99;
  // width: 100%;
  span {
    width: 1rem;
    position: absolute;
    left: 0;
    font-size: 0.5rem;
  }
}
.cs{
  // width: 10rem;
  // height: 10rem;
  // overflow: hidden;
    overflow-x: auto;

  .cs1{
    width: 31rem;
    // height: 10rem;
  .xi{
    width: 2.8rem;
      float: left;

  }
    // animation: move 10s infinite;
    img{
      // width: 5rem;
      width: 100%;
      // padding: 0.5rem;
      padding: 0.2rem;
    }
  }

}
@keyframes move{
  0%{
    transform: translateX(0);
  }
  25%{
    transform: translateX(-2rem);

  }
  50%{
    transform: translateX(-4rem);

  }
  75%{
    transform: translateX(-6rem);

  }
  100%{
    transform: translateX(0);

  }
}
</style>